import { render } from "./customDropdown.vue?vue&type=template&id=ec52530e"
import script from "./customDropdown.vue?vue&type=script&lang=js"
export * from "./customDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__